import http from "@/api.js";

export default {
    emits: ['modal-permission', 'add-role', 'remove-role', 'add-permission', 'remove-permission'],
    data: () => ({
        permissionsdata: [],
    }),
    props: {
        permissions: { type: Array, default: () => [] },
    },
    methods: {
        addRoleToPermission(role){
            const idx = this.permissionsdata.findIndex(p => p.uid === role.uid);
            if (idx == -1){
                this.permissionsdata.push(role);
            }
        },
        removeRoleToPermission(role){
            const idx = this.permissionsdata.findIndex(p => p.uid === role.uid);
            if(idx > -1){
                this.permissionsdata.splice(idx, 1);
            }
        },
        addPermission(folder, role, permission){
            this.$emit('add-permission', {folder, role, permission});
        },
        removePermission(folder, role, permission){
            this.$emit('remove-permission', {folder, role, permission});
        },
        hasPermission(folder, role, permission){
            let field = permission + "_roles";
            return (folder[field].findIndex(r => r.uid === role.uid) > -1);
        },
        updatePermission(data, method){
            this.is_busy = true;
            let url = this.folderUrl(data.folder.uid, "permission/");
            let payload = { role: data.role.uid, permission: data.permission, action: method };
            http.post(url, payload).then(response => {
                this.folderdata.update = response.data;
                this.is_busy = false;
            }).catch(error => {
                this.is_busy = false;
                console.log(error);
            });
        }
    }
}
